/* Shared catalogue matching: accents, vocabulary, plurals and bounded typo tolerance. */
(function (root) {
  const groups = [
    ['carrier', 'carriers', 'bag', 'bags', 'bolso', 'bolsos', 'bolsa', 'bolsas', 'transportin', 'transportines', 'transportador', 'transportadores', 'sac', 'sacs', 'tasche', 'taschen'],
    ['dog', 'dogs', 'perro', 'perros', 'perrito', 'perritos', 'chien', 'chiens', 'hund', 'hunde'],
    ['olive', 'oliva', 'green', 'verde', 'verdes', 'vert', 'verte', 'grun'],
    ['mocha', 'brown', 'marron', 'marrones', 'braun', 'chocolate'],
  ];
  const aliases = new Map(groups.flatMap(group => group.map(word => [word, group[0]])));
  const ignored = new Set(['the', 'a', 'an', 'for', 'in', 'and', 'de', 'del', 'el', 'la', 'los', 'las', 'para', 'un', 'una', 'le', 'les', 'pour', 'der', 'die', 'das', 'fur']);
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const tokenize = value => normalize(value).split(/\s+/).filter(word => word && !ignored.has(word)).map(word => aliases.get(word) || word);
  function closeTypo(a, b) {
    if (a.length < 5 || b.length < 5 || Math.abs(a.length - b.length) > 1) return false;
    if (a.length === b.length) {
      const different = [...a].map((c, i) => c !== b[i] ? i : -1).filter(i => i >= 0);
      return different.length === 1 || (different.length === 2 && different[1] === different[0] + 1 && a[different[0]] === b[different[1]] && a[different[1]] === b[different[0]]);
    }
    const shorter = a.length < b.length ? a : b;
    const longer = a.length < b.length ? b : a;
    let i = 0; while (i < shorter.length && shorter[i] === longer[i]) i++;
    return shorter.slice(i) === longer.slice(i + 1);
  }
  function matches(query, text) {
    const words = tokenize(query), base = tokenize(text);
    const index = [...new Set(base.flatMap(term => [term, ...groups.filter(group => group[0] === term).flat()]))];
    return words.every(word => index.some(term => term === word || (word.length >= 2 && term.startsWith(word)) || closeTypo(word, term)));
  }
  root.FloqSearch = { matches, tokenize };
})(typeof window !== 'undefined' ? window : globalThis);
